
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/examples/more-ways-to-win",
      function () {
        return require("private-next-pages/design-system/examples/more-ways-to-win.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/examples/more-ways-to-win"])
      });
    }
  